export default __webpack_public_path__ + "static/media/2_0050.cd8e1eea.webp";